import { Button, ButtonGroup } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { useCallback, useState } from 'react'

interface IProp {
    onPlus?: () => void
    onMinus?: () => void
}

function PlusAndMinusButton(props: IProp) {
    const { onPlus = () => {}, onMinus = () => {} } = props

    const [isPlus, setIsPlus] = useState<boolean>(true)

    const handleClickPlus = useCallback(() => {
        setIsPlus(true)
        onPlus()
    }, [onPlus])

    const handleClickMinus = useCallback(() => {
        setIsPlus(false)
        onMinus()
    }, [onMinus])

    return (
        <ButtonGroup variant="contained">
            <Button
                variant={isPlus ? 'contained' : 'outlined'}
                onClick={handleClickPlus}
            >
                <AddIcon />
            </Button>
            <Button
                variant={isPlus ? 'outlined' : 'contained'}
                onClick={handleClickMinus}
            >
                <RemoveIcon />
            </Button>
        </ButtonGroup>
    )
}

export default PlusAndMinusButton
